import * as React from 'react'
import Photo from './photo'
import { OrderElement } from '../order_types'
import FilesAttributes from './files_attributes'

const { I18n } = window as any

type ElementProps = {
  element: OrderElement
  subtotal: number
  inputAttributeName: (name: string, row: string) => string
  row: string
  removeElement: (key: string, id: number) => void
  editElement: (element: OrderElement) => void
}

export default function Element(props: ElementProps) {
  const handleRemove = (e: React.MouseEvent) => {
    e.preventDefault()
    const { element, removeElement } = props
    removeElement(element.key, element.id)
  }

  const handleEdit = (e: React.MouseEvent) => {
    e.preventDefault()
    const { element, editElement } = props
    editElement(element)
  }

  const { element, subtotal, inputAttributeName, row } = props
  const stockLevel = element.stock_level || element.template?.stock_level

  let idField = null
  if (element.id !== undefined) {
    const name = inputAttributeName('id', row)
    idField = <input type="hidden" name={name} value={element.id} />
  }

  const getValue = (field: string) => {
    const fieldDefinition = element.template?.fields?.[field]
    let value = null
    if (fieldDefinition !== undefined) {
      const relationValue = fieldDefinition.relation_value
      value = relationValue === undefined ? fieldDefinition.default_value : relationValue
    }
    return value
  }
  const amount = element.amount || element.template?.amount
  const replaceElementId = element.replace_element_id
  const replaceText = replaceElementId ? ` ${I18n.t('elements.order_form.replace_suffix')}` : ''
  const name = getValue('name') + replaceText

  const width = element.width || getValue('width')
  const height = element.height || getValue('height')

  return (
    <tr>
      <td>{amount}</td>
      <td>{stockLevel}</td>
      <td>{getValue('sub_group')}</td>
      <td>{getValue('department')}</td>
      <td>{getValue('sku')}</td>
      <td>{name}</td>
      <td>{getValue('description')}</td>
      <td>{width}</td>
      <td>{height}</td>
      <td>
        <Photo element={element} />
      </td>
      <td>{parseFloat(getValue('price')).toFixed(2)}</td>
      <td>{subtotal.toFixed(2)}</td>
      <td>{element.note || getValue('note')}</td>
      <td>
        <input type="hidden" name={inputAttributeName('amount', row)} value={amount} />
        <input type="hidden" name={inputAttributeName('width', row)} value={width} />
        <input type="hidden" name={inputAttributeName('height', row)} value={height} />
        <input type="hidden" name={inputAttributeName('note', row)} value={element.note || ''} />
        <input type="hidden" name={inputAttributeName('replace_element_id', row)} value={replaceElementId || ''} />
        <input type="hidden" name={inputAttributeName('order_template_id', row)} value={element.template?.id} />
        <FilesAttributes element={element} inputAttributeName={inputAttributeName} row={row} />
        {idField}
        <div className="d-flex flex-nowrap">
          <button type="button" className="btn btn-secondary mr-2" onClick={handleEdit}>
            {I18n.t('elements.actions.edit_element')}
          </button>
          <button type="button" className="remove-element close text-danger" onClick={handleRemove}>
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </td>
    </tr>
  )
}

function elementSubtotal(element) {
  const fields = element.template?.fields || {}
  let subtotal = 0
  let price = 0
  if (fields.price) {
    price = parseFloat(fields.price.default_value)
  }

  const amount = Number(element.amount || element.template?.amount)

  // Price for elements with editable width and height should be calculated
  // with different formula
  const widthField = fields.width
  const heightField = fields.height
  if (widthField && widthField.editable && heightField && heightField.editable) {
    const { width, height } = element
    subtotal = (amount * price * width * height) / 1000000
  } else {
    subtotal = amount * price
  }
  if (Number.isNaN(subtotal)) {
    subtotal = 0
  }

  return subtotal
}

export { elementSubtotal }
